module.exports = __webpack_public_path__ + "img/ic_food_take_out.2a47e2ee.png";